<template>
  <div id="testimonial" class="center" style="padding:25px 10px 65px; width: 100%;">

    <h2 class="pb-2 text-center">客户评价</h2>

    <iframe class="testimaonial-youtube" width="560" height="315" src="https://www.youtube.com/embed/T3g8LVLtAzI" frameborder="0" allowfullscreen></iframe>

    <h2 class="pt-3 text-xs-center">来自ZILLOW平台网站的客户评价</h2>

    <div id="reviews" class="center">

        <div v-for="review in testimonials" style="display:block; padding-top: 25px;">
          <div style="width:100%;text-align: center">
            <table style="margin:0 auto;">
              <tbody>
              <tr>
                <td><p class="reviewTitle" style="font-weight: bold">{{review.title}}</p></td>
              </tr>
              <tr>
                <td><p class="reviewDateAndUrl">{{review.date}}&nbsp;&nbsp;<a v-if="review.url" v-on:click="openUrl(review.url)" style="color:#e8b640" href="#">{{review.url}}</a></p>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
          <div class="review-text">{{review.text}}</div>
        </div>

      </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "testimonial",
    computed: {
      ...mapState({
        testimonials: state => state.testimonialStore.reviews
      }),
    },
    methods: {
      openUrl(url){
        window.open(url)
      }
    }
  }
</script>

<style scoped>
@import "../testimonial.css";
</style>
